import React, { useEffect, useState } from 'react';
import { Button, Input, message, Upload } from 'antd';
import { useDispatch } from 'react-redux';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseColumnPassword from '../../../components/input/base_column_password';
// import BaseColumnSelect from '../../../components/select/base_column_select';
import { restApi, getFileHost, getFileUploadToken } from '../../../apis';
// import { me } from '../../../stores/auth';
const { TextArea } = Input;

const AdminPofile = (props) => {
  const { principal, setLoading, loading, ...rest } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isRead, setRead] = useState(false);
  const dispatch = useDispatch();

  const [state, setState] = useState({
    reload: new Date(),
    name: principal.name,
    email: principal.email,
    address: principal?.info?.address,
    businessRegNumber: principal?.info?.businessRegNumber,
    callCenter: principal?.info?.callCenter,
    companyName: principal?.info?.companyName,
    owner: principal?.info?.owner,
    website: principal?.info?.website,
    bankName: principal?.info?.bankName,
    bankAccountNum: principal?.info?.bankAccountNum,
    //========================================
    photoKey: principal?.photoKey,
    photoPath: principal.photoPath,
    photoExt: principal?.photoExt,
    //========================================
    isChangePasword: false, //true인 경우만 서버에 정보 보내기
    password: '',
    confirmPwd: '',
  });

  useEffect(() => {
    // dispatch(me());
    setLoading(true);
    (async () => {
      await restApi.get('/admin/mypage').then((res) => {
        const account = res?.data?.payload?.account;
        if (account) {
          setState((prev) => {
            return {
              ...prev,
              name: account?.name,
              email: account?.email,
              photoKey: account?.photoKey,
              photoPath: account?.photoPath,
              photoExt: account?.photoExt,
              address: account?.info?.address,
              businessRegNumber: account?.info?.businessRegNumber,
              callCenter: account?.info?.callCenter,
              companyName: account?.info?.companyName,
              owner: account?.info?.owner,
              website: account?.info?.website,
              bankName: account?.info?.bankName,
              bankAccountNum: account?.info?.bankAccountNum,
            };
          });
        }
      });

      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, [state.reload]);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      messageApi.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    const { status } = info.file;

    /*
    // log
    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    */
    if (status == 'uploading') {
      if (loading == false) {
        setLoading(true);
      }
    }
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      // console.log('-[file]--->', info.file);
      const payload = info?.file?.response?.payload;
      if (payload) {
        setState((prev) => {
          return {
            ...prev,
            photoKey: payload?.files[0].id,
            photoPath: payload?.files[0].path,
            photoExt: payload?.files[0].ext,
          };
        });
      }

      setLoading(false);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ ...styles.container }}>
        {contextHolder}
        <div style={{ ...styles.header }}>
          <div style={{ ...styles.title }}>{`최고관리자 프로필`}</div>
          <Button
            style={{ ...styles.botton_update }}
            onClick={(e) => {
              setLoading(true);

              // 수정
              (async () => {
                let body = {
                  name: state?.name,
                  email: state?.email,
                  photoKey: state?.photoKey,
                  photoPath: state?.photoPath,
                  photoExt: state?.photoExt,
                  info: {
                    address: state?.address,
                    businessRegNumber: state?.businessRegNumber,
                    callCenter: state?.callCenter,
                    companyName: state?.companyName,
                    owner: state?.owner,
                    website: state?.website,
                    bankName: state?.bankName,
                    bankAccountNum: state?.bankAccountNum,
                  },
                };

                if (state?.isChangePasword) {
                  body['password'] = state.password;
                }

                // console.log('---update--->', body);
                await restApi
                  .patch(`/admin/account`, {
                    ...body,
                  })
                  .then((res) => {
                    // console.log('--->', res);
                    if (res?.data?.error) {
                      messageApi.error(
                        `[Error] ${
                          res.data.error || '정보를 수정하는데 실패하였습니다.'
                        }`
                      );
                      return res;
                    }

                    return res;
                  });
              })();

              setTimeout(() => {
                setLoading(false);
              }, [3000]);
            }}
          >{`프로필 수정하기`}</Button>
        </div>
        {/* ---------------------------------------------------------------------------------------------------- */}
        <div
          style={{
            ...styles.row,
            padding: '4rem 1rem 4rem 1rem',
            borderBottom: '1px solid #DBDADE',
            alignItems: 'stretch',
          }}
        >
          <div
            style={{
              ...styles.column,
              flex: undefined,
              width: 136,
              height: 136,
              marginLeft: '1rem', // '2.4rem','1.4rem',
              marginRight: '0.9rem',
              alignItems: 'center',
              justifyContent: 'center',
              // border: '1px solid #DBDADE',
              backgroundRepeat: 'no-repeat',
              backgroundImage: `url(${require('../../../assets/images/bkg_profile.png')})`,
            }}
          >
            <Upload
              name="avatar"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              //---------------------------------------------
              action={getFileHost()}
              headers={{
                Authorization: `Bearer ${getFileUploadToken()}`,
              }}
              method="post"
              //Content-Disposition: form-data; name="Filedata"; filename="undefined"
              // name="filedata" /// <=== 파일 데이터 저장할 이름
              //---------------------------------------------
            >
              {state?.photoPath ? (
                <img
                  width={136}
                  height={136}
                  // src={`url(${require('../../../assets/images/sample_profile.png')})`}
                  // src={require('../../../assets/images/sample_profile.png')}
                  src={`https://cdn.humanb.kr/${state?.photoPath}/${state?.photoKey}.${state?.photoExt}`}
                  alt={`no image`}
                />
              ) : (
                <div style={{ marginTop: 8 }}>{`프로필 등록`}</div>
              )}
            </Upload>
          </div>

          <div style={{ ...styles.column }}>
            <BaseColumnInput
              label={`성명`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    name: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.name}
            />
            <BaseColumnInput
              label={`정산 계좌 은행`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    bankName: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.bankName}
            />
          </div>
          <div style={{ ...styles.column }}>
            <BaseColumnInput
              label={`이메일`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    email: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.email}
            />
            <BaseColumnInput
              label={`정산 계좌 번호`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    bankAccountNum: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.bankAccountNum}
            />
          </div>
          <div style={{ ...styles.column }}>
            <BaseColumnPassword
              label={`비밀번호`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    isChangePasword: true,
                    password: e.target.value,
                  };
                });
              }}
              placeholder={'********'}
              width={'32rem'}
            />
            <BaseColumnPassword
              label={`비밀번호 확인`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    confirmPwd: e.target.value,
                  };
                });
              }}
              placeholder={'********'}
              width={'32rem'}
            />
          </div>
        </div>
        {/* ---------------------------------------------------------------------------------------------------- */}
        <div
          style={{
            ...styles.row,
            padding: '3rem 1rem 3rem 1rem',
            borderBottom: '1px solid #DBDADE',
          }}
        >
          <div style={{ ...styles.column }}>
            <BaseColumnInput
              label={`상호`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    companyName: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.companyName}
            />
            <BaseColumnInput
              label={`주소`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    address: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.address}
            />
            <BaseColumnInput
              label={`사업자 등록 번호`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    businessRegNumber: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.businessRegNumber}
            />
          </div>
          {/* **************************************************** */}
          <div style={{ ...styles.column }}>
            <BaseColumnInput
              label={`대표 성명`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    owner: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.owner}
            />
            <BaseColumnInput
              label={`홈페이지 URL`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    website: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.website}
            />
            <BaseColumnInput
              label={`기업 전화번호`}
              readonly={isRead}
              onChange={(e) => {
                setState((prev) => {
                  return {
                    ...prev,
                    callCenter: e.target.value,
                  };
                });
              }}
              width={'32rem'}
              placeholder={state?.callCenter}
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: 24 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: '#FFF',
    boxShadow: '0px 4px 18px rgba(75, 70, 92, 0.1)',
    borderRadius: 6,
    padding: 0,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    /*
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
		*/
  },

  header: {
    display: 'flex',
    width: '100%',
    height: '6.8rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #DBDADE',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  title: {
    display: 'flex',
    width: '50rem',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',

    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    // letterSpacing: 1,
    // textTransform: 'uppercase',
  },
  col_title: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    //font
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  botton_update: {
    display: 'flex',
    width: '14.3rem',
    height: '3.8rem',
    alignItems: 'center',
    justifyContent: 'center',

    border: 0,
    background: `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`,
    // ...item.style,
    color: '#FFF',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    // height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 0.9rem 0rem 0.9rem',
    background: '#FFFFFF',
  },
};
export default AdminPofile;
